export const schedules = [
  {
    day: new Date('Jun 8, 2021'),
    schedules: [
      {
        start: '08h00',
        end: '08h20',
        localeId: 'schedule.schedules.day-1.event-1',
      },
      {
        start: '08h20',
        end: '10h15',
        localeId: 'schedule.schedules.day-1.event-2',
      },
      {
        start: '10h15',
        end: '10h35',
        localeId: 'schedule.schedules.day-1.event-3',
      },
      {
        start: '10h35',
        end: '11h50',
        localeId: 'schedule.schedules.day-1.event-4',
      },
      {
        start: '11h50',
        end: '12h20',
        localeId: 'schedule.schedules.day-1.event-5',
      },
      {
        start: '12h20',
        end: '12h30',
        localeId: 'schedule.schedules.day-1.event-6',
      },
    ]
  },
  {
    day: new Date('Jun 9, 2021'),
    schedules: [
      {
        start: '08h00',
        end: '08h20',
        localeId: 'schedule.schedules.day-2.event-1',
      },
      {
        start: '08h20',
        end: '09h05',
        localeId: 'schedule.schedules.day-2.event-2',
      },
      {
        start: '09h05',
        end: '10h25',
        localeId: 'schedule.schedules.day-2.event-3',
      },
      {
        start: '10h25',
        end: '10h45',
        localeId: 'schedule.schedules.day-2.event-4',
      },
      {
        start: '10h45',
        end: '12h05',
        localeId: 'schedule.schedules.day-2.event-5',
      },
      {
        start: '12h05',
        end: '12h30',
        localeId: 'schedule.schedules.day-2.event-6',
      },
    ]
  },
]
